export class TaskCreateRequest {

    _year;
    _month;
    _constructionId;
    _companyId;

    constructor(values) {
        this._year = values.year;
        this._month = values.month;
        this._constructionId = values.constructionId;
        this._companyId = values.companyId;
    }

    body() {
        return {
            year: this._year,
            month: this._month,
            construction_id: this._constructionId,
            company_id: this._companyId,
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/form/create/ws/TaskCreateRequest.js